// extracted by mini-css-extract-plugin
export default {"category-products_list":"CategoryProducts_category-products_list__FE6FS"};